import { toast, ToastPosition } from 'react-toastify';

type ToastSettings = {
  copySuccessText: string;
  copyErrorText: string;
};

export class ClipboardUtilsImpl {
  private readonly toastSettings: ToastSettings;
  private readonly toastPosition: ToastPosition = 'bottom-right';

  constructor(toastSettings: ToastSettings) {
    this.toastSettings = toastSettings;
  }

  public async copy(textToCopy: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(textToCopy);
      toast(this.toastSettings.copySuccessText, {
        type: 'success',
        position: this.toastPosition,
      });
    } catch (error) {
      toast(this.toastSettings.copyErrorText, {
        type: 'error',
        position: this.toastPosition,
      });
    }
  }
}
